/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useContext, useEffect, useMemo, useState } from 'react'
import moment from 'moment';

// @material-ui
import {
    Box,
    Checkbox,
    DataGrid,
    FormControl,
    FormControlLabel,
    MenuItem,
    Select,
    Typography,
} from "../../../components/shared/MaterialUI";

// @style
import { EditPayrollStyle, TableInvoiceStyle } from '../../../assets/css/payroll-style';
import CustomNoRowsOverlay from '../../../assets/CustomNoRowsOverlay';
import { componentsStyles } from '../../../assets/css/tableComponents-styles';

// @components
import ConfirmationDialog from '../../../components/dialog/DialogConfirm';
import { payrollContext } from '../payrollView';

// @context
import { useUI } from '../../../app/context/ui';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import { formatCurrency, MenuItemProps, monthsList } from '../../../helpers/FunctionsUtils';

// @services
import PayrollService from '../../../services/newApi/PayrollService';
import EmployeesInvoiceModal from './components/EmployeesInvoiceModal';

// @hokks
import UseMediaQuerys from '../../../hooks/UseMediaQuerys';
import { theme } from '../../../assets/theme';

const InvoiceSumary = () => {
    const {dataInvoice, getRecordsList} = useContext(payrollContext);
    const styles = TableInvoiceStyle();
    const style = useMemo(() => EditPayrollStyle(), []);
    const payrollService = useMemo(() =>  new PayrollService(), []);
    const [info, setInfo] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const { blockUI, snackbarUI } = useUI();
    const [itemToUpdate, setItemToUpdate] = useState();
    const [open, setOpen] = useState(false);
    const [companyId, setCompanyId] = useState(null);
    const getMonth = () => new Date().getMonth() + 1;
    const [monthSelected, setMonthSelected] = useState(getMonth);
    const {isXs, isSm} = UseMediaQuerys();
    
    const handleCloseModal = (value) => {
        if(value) updateInvoiceSent(itemToUpdate);
        setOpenDialog(false);
    }

    const handleChange = (e, item) => {
        const params = {
            companyId: item?.companyId,
            year: item?.year,
            month: item?.month,
            invoice: e.target.checked ? true : false
        }
        setItemToUpdate(params);
        if(e.target.checked)return updateInvoiceSent(params)
        else setOpenDialog(true)
    }

    const updateInvoiceSent = async (params) => {
        try {
            blockUI.current.open(true);
            await payrollService.updateInvoiceStatus(params);
            getRecordsList();
            blockUI.current.open(false);
        } catch (error) {
            blockUI.current.open(false);
            AppHelper.checkError(error, snackbarUI);
        }
    }

    const handleClose = () => setOpen(!open);

    const columns = [
        {
            field: 'updateAt',
            headerName:'Last Sync Date',
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            hide: isXs || isSm ? true : false,
            flex: 1,
            renderCell: (params) => (
                <Box>
                  {moment(params.row.updateAt).format('MM-DD-YY')}
                </Box>
            ),
        },
        {
            field: 'employer',
            headerName: 'Employeer',
            disableColumnMenu: true,
            flex: 1,
            renderCell: (params) => (
                <Box
                  onClick={() => {
                    handleClose(); 
                    setCompanyId(params?.row?.companyId);
                  }}
                  sx={styles.link}
                >
                  {params?.row?.employer}
                </Box>
              ),
        },
        {
            field: 'totalInvoice',
            headerName: 'Invoice YTD ($)',
            disableColumnMenu: true,
            flex: 1,
            hide: isXs ? true : false,
            renderCell: (params) => (
                <Box>
                  {formatCurrency(params.row.totalInvoice)}
                </Box>
            ),
        },
        {
            field: 'currentInvoice',
            headerName: 'Actual Invoice ($)',
            disableColumnMenu: true,
            flex: 1,
            hide: isXs || isSm ? true : false,
            renderCell: (params) => (
                <Box>
                  {formatCurrency(params.row.currentInvoice)}
                </Box>
            ),
        },
        {
            field: 'newTaxCredit',
            headerName: 'New Credits',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            hide: isXs || isSm ? true : false,
            renderCell: (params) => (
                <Box>
                  {formatCurrency(params.row.newTaxCredit)}
                </Box>
            ),
        },
        {
            field: 'ytdTaxCredit',
            headerName: 'Total Credits',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            renderCell: (params) => (
                <Box>
                  {formatCurrency(params.row.ytdTaxCredit)}
                </Box>
            ),
        },
        {
            field: 'isInvoiceSend',
            headerName: 'Invoice Sent',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            renderCell: (params) => (
                <FormControlLabel
                    checked={params?.row?.isInvoiceSend}
                    control={
                        <Checkbox 
                            onChange={(e) => handleChange(e, params.row)}
                            sx={{
                                color: theme.payroll.greenMain,
                                '& .MuiSvgIcon-root': {fontSize: '24px'},
                                '&.Mui-checked': {
                                    color: theme.payroll.greenMain,
                                }
                            }}
                        />}
                    label="Yes"
                    labelPlacement="end"
                />
            ),
        },
    ];
  
    useEffect(() => {
        setInfo(dataInvoice ?? [])
    }, [dataInvoice])

    const FetchSumaryInvoice = async (month) => {
        setMonthSelected(month);
        getRecordsList({month});
    }
  
  return (
    <>
        <Box
            sx={{
                ...style.containerSelect,
                margin: '5px 0px 20px 0px',
                paddingLeft: '20px',
                width: '100%',
            }}
        >
            <Typography sx={style.labelSelect} >Select Month</Typography>
            <FormControl>
                <Select
                    value={monthSelected}
                    id='selectYear'
                    onChange={(e)=> {FetchSumaryInvoice(e.target.value)}}
                    size="small"
                    variant="outlined"
                    sx={style.fieldsInput}
                    MenuProps={MenuItemProps}
                    margin="dense" 
                >
                    {monthsList?.map((item, index) => (
                        <MenuItem value={item.id} key={index}>
                            {item.month}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
        <DataGrid
            columns={columns}
            rows={info}
            components={{ NoRowsOverlay: CustomNoRowsOverlay }}
            componentsProps={componentsStyles}
            headerHeight={80}
            rowHeight={70}
            disableSelectionOnClick
            checkboxSelection={false}
            sx={{...styles.tableGrid, minHeight: '350px'}}
            hideFooter={true}
            hideFooterPagination={true}
        />

        <ConfirmationDialog
            id="confirm-dialog"
            onClose={handleCloseModal}
            open={openDialog}
            view="payroll"
            title="Are you sure you want to Uncheck?"
        />
        
        <EmployeesInvoiceModal
            open={open}
            handleClose={handleClose}
            companyId={companyId}
        />
    </>
  )
}

export default InvoiceSumary
